import React from "react";
import Rbottom from "../Components/Rbottom";
import Rtop from '../Components/Rrtop.js';

function Resources() {
  return (
    <>
      <Rtop />
      <Rbottom />
    </>
  );
}

export default Resources;